import * as React from 'react';
import { compose, pure } from 'recompose';
import { createStyles, withStyles } from '@material-ui/styles';
import MenuItemMUI from '@material-ui/core/MenuItem';
const styles = (theme) => createStyles({
    root: {
        transition: 'all 50ms linear',
        '&:hover:not($selected)': {
            fontWeight: theme.font.weight.bold,
        },
    },
    selected: {
        fontWeight: theme.font.weight.bold,
        backgroundColor: `${theme.color.primary.main} !important`,
        color: `${theme.color.font.light} !important`,
    },
});
const SelectItem = ({ theme, testId = 'Select', ...other }) => (React.createElement(MenuItemMUI, Object.assign({ "data-testid": `${testId}` }, other)));
export default compose(withStyles(styles, { withTheme: true }), pure)(SelectItem);
//# sourceMappingURL=SelectItem.js.map